<template>
	<datatable
		v-model:server-options="params"
		size="large"
		:total
		:rows="params.rowsPerPage"
		:headers
		:value="items"
		:loading
		clickable
		@row-click="handleRowClick">
		<template #row-contract_status="{ row }">
			<app-tooltip :text="getStatusIcon(row).label" position-x="left" small>
				<div class="inline-flex items-center justify-center w-10">
					<app-svg
						:path="`/icons/catalyst/${getStatusIcon(row).icon}.svg`"
						:background="getStatusIcon(row).colour"
						autoscale />
				</div>
			</app-tooltip>
		</template>

		<template #row-item_weight="{ row }">
			{{ row.item_weight }}
		</template>
	</datatable>
</template>

<script lang="ts" setup>
	import type { Row } from '@/data/types/datatable'
	import { computed, watch } from 'vue'
	import { useRouter } from 'vue-router'
	import { useDatatable } from '@/composables/datatable.js'
	import { useContractStatus } from '@/composables/status'
	import AppSvg from '@/components/base/AppSvg.vue'

	const router = useRouter()
	const { params } = useDatatable()

	const props = defineProps({
		items: {
			type: Array<Row>,
			default: []
		},
		total: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean
		},
		completedItems: {
			type: Boolean
		}
	})

	function handleRowClick(item: Row) {
		if (item && item.id && !props.completedItems) {
			router.push(`/yard-app/load-item/${item.contract_number}`)
		}
	}

	function getStatusIcon(item) {
		const { label, icon, colour } = useContractStatus(item.contract_status)

		return {
			label: label.value,
			icon: icon.value,
			colour: colour.value
		}
	}

	const headers = computed(() => {
		if (props.completedItems) {
			return [
				{ value: 'contract_status', text: 'Status' },
				{ value: 'contract_number', text: 'Contract Number', props: { sortable: true } },
				{ value: 'account', text: 'Account Number', props: { sortable: true } },
				{ value: 'delivery_date', text: 'Del Date', props: { sortable: true } },
				{ value: 'item_count', text: 'No of Items', props: { sortable: true } },
				{ value: 'item_weight', text: 'Weight (tonnes)', props: { sortable: true } },
				{ value: 'delivery_vehicle', text: 'Delivery Vehicles' }
			]
		}

		return [
			{ value: 'contract_number', text: 'Contract Number', props: { sortable: true } },
			{ value: 'account', text: 'Account Number', props: { sortable: true } },
			{ value: 'delivery_date', text: 'Del Date', props: { sortable: true } },
			{ value: 'item_count', text: 'No of Items', props: { sortable: true } },
			{ value: 'item_weight', text: 'Weight (tonnes)', props: { sortable: true } }
		]
	})

	const emit = defineEmits(['paramsChanged'])

	watch(
		params,
		() => {
			emit('paramsChanged', params.value)
		},
		{ deep: true }
	)
</script>
